var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/react-share/~/core-js/library/modules/_html.js
// module id = 1998
// module chunks = 2